import React, { useState } from 'react';
import {
  ActivityIndicator, ImageBackground, TextInput, View,
} from 'react-native';
import {
  Button, Colors, Dialog, Paragraph, Portal,
} from 'react-native-paper';
import { useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { Header } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import { API } from '../../../service/api';
import styles from './styles';

const AlterPersonalData = ({ navigation }) => {
  const { workerData } = useSelector((state) => state.worker);
  const [name, setName] = useState(workerData?.nome);
  const [email, setEmail] = useState(workerData?.email);
  const [phone, setPhone] = useState(workerData?.telefone);
  const [jobPosition, setJobPosition] = useState(workerData?.cargo);
  const [isLoading, setLoading] = useState(false);
  const [passOK, setPassOK] = useState(false);
  const [passError, setPassError] = useState(false);

  async function handleAlterData() {
    setLoading(true);
    const { id_empresa, id_setor, id_colaborador } = workerData;
    const data = {
      id_colaborador_temp: id_colaborador,
      id_empresa,
      id_setor,
      nome: name,
      email,
      telefone: phone,
      cargo: jobPosition,
    };

    try {
      await API.post('/create/colaborador_temp', data);
      setPassOK(true);
    } catch (err) {
      console.log(err);
      setPassError(true);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Portal>
        <Dialog visible={passOK} onDismiss={() => setPassOK(false)}>
          <Dialog.Title>Solicitação Enviada</Dialog.Title>
          <Dialog.Content>
            <Paragraph>Sua Solicitação de alteração de dados foi enviada!</Paragraph>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => { setPassOK(false); navigation.goBack(); }}>Ok</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <Portal>
        <Dialog visible={passError} onDismiss={() => setPassError(false)}>
          <Dialog.Title>Erro na Solicitação</Dialog.Title>
          <Dialog.Content>
            <Paragraph>Não foi possível fazer sua solicitação.</Paragraph>
            <Paragraph>Talvez sua última solicitação ainda esteja em processamento.</Paragraph>

          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => { setPassError(false); }}>Ok</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <ImageBackground source={leths_back} style={styles.viewBase}>
        <Header navigation={navigation} profilePic={workerData.foto} userName={workerData.nome} />
        <View style={styles.content}>
          <AppText size="bold" style={styles.titleContent}>Alterar Dados Pessoais</AppText>
          <View style={styles.viewForm}>
            <View>
              <TextInput
                value={name}
                onChangeText={(newName) => setName(newName)}
                placeholder="Nome"
                style={styles.input}
              />
            </View>
            <View>
              <TextInput
                value={email}
                onChangeText={(newEmail) => setEmail(newEmail)}
                placeholder="Email"
                style={styles.input}
              />
            </View>
            <View>
              <TextInput
                value={phone}
                type="cel-phone"
                onChangeText={(newPhone) => setPhone(newPhone)}
                placeholder="Telefone"
                style={styles.input}
              />
            </View>
            <View>
              <TextInput
                value={jobPosition}
                onChangeText={(newJobPosition) => setJobPosition(newJobPosition)}
                placeholder="Cargo"
                style={styles.input}
              />
            </View>

            <AppButton
              size="bold"
              disabled={isLoading || name === '' || email === '' || jobPosition === '' || phone === ''}
              label={isLoading ? <ActivityIndicator color="#FFF" size={pixelDimensions(7)} /> : 'SOLICITAR ALTERAÇÕES'}
              labelStyle={styles.textButton}
              onPress={() => !isLoading && handleAlterData()}
              style={styles.button}
            />
          </View>
          <AppButton size="bold" label="VOLTAR" rippleColor={Colors.indigo700} style={styles.buttonBack} labelStyle={styles.textBack} onPress={() => navigation.goBack()} />
        </View>
      </ImageBackground>
    </>
  );
};

export default AlterPersonalData;
